import CopyableTextWithTooltip from '~/common/components/CopyableTextWithTooltip/CopyableTextWithTooltip';
import {
  LoaderItem,
  LoaderItemLabel,
} from '~/common/components/Nav/LeftDrawer/components/LoaderItem';
import Text from '~/common/components/Texts/Text';
import useGetLoanSummary from '~/common/hooks/useGetLoanSummary';

import RatioInfoStack from './RatioInfoStack/RatioInfoStack';
import {
  CopyableTextStyle,
  LeftDrawerLoanSummaryContainer,
  LoaderStack,
  LoanSummaryBox,
} from './Styled';

const LeftDrawerLoanSummary = () => {
  const { data, isError, isPlaceholderData } = useGetLoanSummary();

  const propertyAddress = data?.propertyData?.propertyAddress;

  const formattedAddress = propertyAddress
    ? [
        propertyAddress.addressLine1,
        propertyAddress.unit,
        propertyAddress.city,
        propertyAddress.state,
        propertyAddress.zipCode,
      ]
        .filter(Boolean)
        .join(', ')
    : '';

  return (
    <LeftDrawerLoanSummaryContainer data-testid="leftDrawerLoanSummaryContainer">
      {isPlaceholderData && (
        <LoaderStack>
          <LoaderItemLabel text="PLEASE WAIT" />
          <LoaderItem className="loader" />
        </LoaderStack>
      )}
      {isError && <Text>Error: Could not retrieve loan Summary Data</Text>}

      {!isPlaceholderData && !isError && data && (
        <LoanSummaryBox>
          <CopyableTextWithTooltip
            text={String(data?.loanInfo?.loanNumber)}
            valueToCopy={String(data?.loanInfo?.loanNumber)}
            maxWidth={'168px'}
            textStyle={CopyableTextStyle}
          />

          <CopyableTextWithTooltip
            text={`${data?.borrower?.firstName} ${data?.borrower?.lastName}`}
            valueToCopy={`${data?.borrower?.firstName} ${data?.borrower?.lastName}`}
            maxWidth={'168px'}
          />
          <RatioInfoStack
            dti={data?.loanInfo?.dti}
            hti={data?.loanInfo?.hti}
            ltv={data?.loanInfo?.ltv}
            cltv={data?.loanInfo?.cltv}
            hcltv={data?.loanInfo?.hcltv}
          />
          <CopyableTextWithTooltip
            dataTestId="leftNavAddress"
            text={formattedAddress}
            valueToCopy={formattedAddress}
            maxWidth={'168px'}
          />
        </LoanSummaryBox>
      )}
    </LeftDrawerLoanSummaryContainer>
  );
};

export default LeftDrawerLoanSummary;
